import { ExportFileFormat, SystemLayout } from '../models/settings';

export function getAvailableLayoutsFromFormat(format: ExportFileFormat, layouts: SystemLayout[]) {
  return layouts.filter((l) => l.fileFormat === format);
}
